import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import TimeUtil from 'time';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';

/**
 * Featured Preset Time component
 */
export default React.createClass({
  displayName: 'FeaturedPresetTime',

  mixins: [PureRenderMixin],

  propTypes: {
    item: React.PropTypes.any.isRequired,
  },

  render() {
    let { presetDurationDisplayType, item } = this.props;
    let value = item.get('presetDurationInSecondsAdjusted');

    let presetDuration = TimeUtil.getShorthandFormattedPresetDuration(value);

    if (presetDurationDisplayType === TimeDisplayTypes.sixDigitTime)
      presetDuration = TimeUtil.getFormattedDuration(value);
    if (presetDurationDisplayType === TimeDisplayTypes.presetTime)
      presetDuration = TimeUtil.getFormattedPresetDuration(value);

    return <div className="featured-preset-time">{presetDuration}</div>;
  },
});
